export const V1_RECEIVE_ERRORS = 'V1_RECEIVE_ERRORS'

export default errors => ({
  type: V1_RECEIVE_ERRORS,
  errors,
})
